import { render } from "./AssignmentForm.vue?vue&type=template&id=5b7f3754&scoped=true&ts=true"
import script from "./AssignmentForm.ts?vue&type=script&lang=ts"
export * from "./AssignmentForm.ts?vue&type=script&lang=ts"

import "./AssignmentForm.scss?vue&type=style&index=0&id=5b7f3754&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b7f3754"]])

export default __exports__